import { MAX_FILTER_VALUES } from '../aiAnalyticsConstants';
import { columnName, normalizeRow } from '../services/aiDataUtils';

export function normalizeRows(rows, columns) {
  return (rows || []).map(row => normalizeRow(row, columns));
}

export function buildAvailableFields(columns, rows) {
  return (columns || [])
    .map((column, index) => {
      const field = columnName(column, index);
      const values = [...new Set(rows.map(row => row[field]).filter(v => v !== null && v !== undefined))];
      return { field, values };
    })
    .filter(entry => entry.values.length > 1 && entry.values.length <= MAX_FILTER_VALUES);
}

export function applyFilters(rows, filters) {
  if (!filters.length) {
    return rows;
  }
  return rows.filter(row => filters.every(filter => filter.values.includes(row[filter.field])));
}
